// extracted by mini-css-extract-plugin
export default {"question":"Question_question__VDQQv","qtitle":"Question_qtitle__nm6m0"};